export enum FinancialYearStatus {
    Open = 'Open',
    Closed = 'Closed'
}

export const FinancialYearStatusTranslations: Record<string, string> = {
    [FinancialYearStatus.Open]: 'FINANCIALYEAR.STATUS.OPEN',
    [FinancialYearStatus.Closed]: 'FINANCIALYEAR.STATUS.CLOSED'
};
